// import Global from "./globals";
import { MainContainer, AppWrapper, MainClasses } from "./main";

export default {
  // from main
  MainContainer,
  AppWrapper,
  MainClasses,
};
